{
  "common": {
    "for": "für",
    "each": "jede",
    "eachLot": "Jede katalognummer",
    "lot": "katalognummer",
    "lots": "katalognummern",
    "selectAll": "Alles auswählen",
    "unselectAll": "Nichts auswählen"
  },
  "pageHeader": {
    "techSupport": "Technische Hilfe",
    "auctionCompany": "Auktionsfirma",
    "welcome": "Willkommen",
    "bidder": "Bieter",
    "viewer": "Besucher",
    "fullCatalog": "Kompletter Katalog"
  },
  "catalogAndMyPurchases": {
    "firstTab": "Katalog",
    "secondTab": "Meine Käufe",
    "trackLots": "Katalog erlauben die Lots zu merken",
    "backToLots": "Zurück zu den Auktionsnummern",
    "passed": "Vorbei",
    "pending": "Steht aus",
    "sold": "Verkauft",
    "biddingNow": "Jetzt Bieten",
    "upNext": "Nächste",
    "confirmPurchases": "Alle Käufe müssen von der Auktionsfirma bestätigt werden",
    "lot": "Nummer",
    "backToMyPurchases": "Zurück zu meinen Käufen"
  },
  "chat": {
    "loading": "Unterhaltung wird geladen ...",
    "header": "Online Unterhaltung"
  },
  "mediaStreaming": {
    "failedConnection": "Verbindung unterbrochen!",
    "playBtn": "Live Video abspielen",
    "connecting": "Wird verbunden ...",
    "unmute": "Stummschaltung aufheben",
    "mute": "Stumm schalten",
    "tooltip": "Sie sind erfolgreich verbunden"
  },
  "biddingArea": {
    "auctionPaused": "Auktion ist unterbrochen",
    "waitingAuctionToStart": "Auktion startet bald",
    "waitingBiddingToStart": "Bieten wird gleich eröffnet",
    "auctioneerConfirmed": "Der Auktionator bestätigt Ihnen",
    "soldPriceForEach": "Verkaufspreis pro Stück",
    "winningBid": "Gewinner",
    "pendingSellerConfirmationForEach": "Verkäufer Bestätigung steht aus.",
    "pendingBid": "Ausstehendes Gebot",
    "auctioneerRefused": "Die Bestätigung des Auktionators wurde zurück genommen.",
    "sold": "Verkauft!",
    "pendingSellerConfirmation": "Ausstehende Verkäufer Information",
    "bid": "Bieten",
    "roundCancelled": "Runde wurde abgebrochen",
    "noSale": "Vorbei",
    "highestBidder": "Glückwunsch, Sie sind Höchstbietend!",
    "youWon": "Glückwunsch, Sie haben gewonnen!",
    "waitingWinner": "Der Gewinner muss noch auswählen…",
    "totalPrice": "Paketpreis",
    "yourBidPending": "Ihr Gebot muss noch bestätigt werden",
    "waitingWinnerChooseLots": "Ausstehende Verkäufer Information, der Höchstbietende muss noch auswählen.…",
    "youAreIn": "Sie sind eingeloggt!",
    "viewOnly": "NUR ZUSCHAUEN!",
    "registerLogin": "Registrieren/Einloggen ",
    "clickToBid": "Klicken zum BIETEN!",
    "swipeToBid": "Zum BIETEN wischen ",
    "waitingIncrement": "Es wird auf die Reihenfolge gewartet.",
    "totalBid": "Gesamt Anzahl an Geboten",
    "bidHistory": "Verlauf der Gebote",
    "floorFirst": "Auktionshalle zuerst",
    "waitAuctioneer": "Bitte warten Sie bis der Auktionator ihre Auswahl bestätigt hat.",
    "makeSelections": "Bitte treffen Sie ihre Wahl!",
    "pricePendingConfirmation": "Preis variiert, Verkäufer muss bestätigen",
    "selectionSent": "Auswahl gesendet",
    "sendSelection": "Auswahl senden"
  },
  "currentRound": {
    "nowBidding": "Jetzt Bieten",
    "scrollList": "Hier runterscrollen"
  },
  "webcastFinished": "Das Webcast-Event ist beendet. Vielen Dank."
}
